<template>
  <div class="giftshow">
    <span class="mask"></span>
    <Svgaplayer
      :loops="0"
      class="guang"
      src="https://yun.duiba.com.cn/polaris/%E6%8A%BD%E5%8D%A1%E5%BC%B9%E7%AA%97%E7%AD%89%E6%B0%9B%E5%9B%B4%E5%85%89%E6%95%88.020499dbadc56794bbb287365aae72dbe38d0f18.svga"
    >
    </Svgaplayer>

    <Svgaplayer
      v-if="!isAniEnd"
      :loops="1"
      class="mix_svga"
      src="https://yun.duiba.com.cn/polaris/mixin.80d9d294fa8102b6deea26e3d10908bfae2ab835.svga"
      :onFinished="onAniFinish"
    >
    </Svgaplayer>
    <div class="boxContent" v-if="isAniEnd">
      <div
        class="prize_img"
        :style="{ backgroundImage: `url(${giftData.prizeImg})` }"
      ></div>
      <div class="btn" @click="handleClick"></div>
    </div>
    <div v-if="isAniEnd" class="close" @click="onClose"></div>
  </div>
</template>

<script>
import Svgaplayer from "../SvgaPlayer/index.vue";
export default {
  name: "GiftShow",
  props: ["handleClose", "giftData", "platform"],
  data: () => {
    return {
      isAniEnd: false,
    };
  },
  components: {
    Svgaplayer,
  },

  methods: {
    handleClick() {
      console.log(this.platform);

    //   if (this.platform.indexof("mp-weixin" > -1)) {
      // uni.webView.navigateTo({
      //   url: "/pages/tabbar/home/web-view?IM=1572173061631827970", // 跳转小程序的地址
      // });
        uni.navigateTo({
          url: "/pages/tabbar/home/web-view?IM=1572173061631827970", // 跳转小程序的地址
        });
    //   } else {
        // wx.miniProgram.navigateTo({
        //   url: "/pages/tabbar/home/web-view?IM=1572173061631827970", // 跳转小程序的地址
        // });
    //   }
      this.$emit("handleClose");
    },
    onAniFinish() {
      this.isAniEnd = true;
    },
    onClose() {
      this.$emit("handleClose");
    },
  },
  mounted() {
    try {
    } catch (error) {}
  },
};
</script>

<style scoped lang="less">
@import "../../res.less";

.giftshow {
  width: 7.5rem;
  height: 16.24rem;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%) translateZ(100px);

  .mask {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgb(0, 0, 0);
    opacity: 0.7;
    position: absolute;
  }

  .boxContent {
    width: 7.5rem;
    height: 8.83rem;
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%) translateZ(100px);
    .sparkBg("GiftShow/bg.png");
    animation: fade_in 1s both;

    .prize_img {
      width: 2.5rem;
      height: 2.5rem;
      top: 3rem;
      left: 50%;
      transform: translate(-50%, -50%);
      position: absolute;
      .bgwithoutUrl;
    }

    .btn {
      width: 3.31rem;
      height: 1.03rem;
      position: absolute;
      left: 50%;
      transform: translate(-50%, 0);
      top: 7rem;
      .sparkBg("GiftShow/btn.png");
    }
  }

  .guang {
    width: 7.5rem;
    height: 14.08rem;
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .close {
    width: 0.58rem;
    height: 0.58rem;
    position: absolute;
    left: 50%;
    top: 12rem;
    transform: translate(-50%);
    .sparkBg("GiftShow/close.png");
  }

  .mix_svga {
    width: 7.5rem;
    height: 16.24rem;
    position: absolute;
  }

  @keyframes fade_in {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GiftShow/index.vue